import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=33551108"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"
import style0 from "./realName.vue?vue&type=style&index=0&id=33551108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports